import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { findProject } from '../data/projectsData';
import Lightbox from '../components/Lightbox';
import usePageMeta from '../hooks/usePageMeta';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK } from '../config';

// Fallback image component
const ImageWithFallback = ({ src, alt, ...props }) => {
    const handleError = (e) => {
        e.target.onerror = null; // prevents looping
        e.target.src = '/images/assets/main.png';
    };

    return <img src={src} alt={alt} onError={handleError} {...props} />;
};

function ProjectDetailPage() {
  const { projectId } = useParams();
  const project = findProject(projectId);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  usePageMeta(project?.title, project?.shortDescription);

  if (!project) {
    return (
      <div id="main">
        <section className="post" style={{ textAlign: 'center', padding: '5rem 2rem' }}>
          <h1>הפרויקט לא נמצא</h1>
          <Link to="/projects" className="button">חזרה לכל הפרויקטים</Link>
        </section>
      </div>
    );
  }

  const lightboxImages = project.gallery.map((src, i) => ({ src, alt: `${project.title} — תמונה ${i + 1}` }));

  return (
    <div id="main">
      <section className="post">
        <Link to="/projects" className="back-link">
          <i className="fa fa-arrow-right"></i> חזרה לכל הפרויקטים
        </Link>
        <header className="major">
          <h1>{project.title}</h1>
        </header>
        <div className="image main">
          <ImageWithFallback src={project.mainImage} alt={project.title} />
        </div>
        <div className="project-description" dangerouslySetInnerHTML={{ __html: project.fullDescription }} />

        {project.gallery.length > 0 && (
          <>
            <hr />
            <h2>גלריית תמונות מהפרויקט</h2>
            <div className="gallery">
              {project.gallery.map((image, index) => (
                <button
                  type="button"
                  className="gallery-item"
                  key={image}
                  onClick={() => setLightboxIndex(index)}
                  aria-label={`הגדלת תמונה ${index + 1}`}
                >
                  <ImageWithFallback
                    src={image}
                    alt={`${project.title} — תמונה ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                  />
                </button>
              ))}
            </div>
          </>
        )}

        <div className="project-cta">
          <h3>מתעניינים בפרויקט דומה?</h3>
          <p>נשמח לספר לכם עוד, לייעץ ולתאם פגישת היכרות ללא התחייבות.</p>
          <div className="hero-buttons">
            <a href={`tel:${PHONE_TEL}`} className="button primary">
              <i className="fa fa-phone icon"></i> {PHONE_DISPLAY}
            </a>
            <a href={WHATSAPP_LINK} className="button whatsapp" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp icon"></i> וואטסאפ
            </a>
          </div>
        </div>
      </section>

      {lightboxIndex !== null && (
        <Lightbox
          images={lightboxImages}
          index={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={setLightboxIndex}
        />
      )}
    </div>
  );
}

export default ProjectDetailPage;
